import clsx from 'clsx';
import { Image } from '@marriott/mi-ui-library';
import { AssetVariation, HeroSize } from '../../../utils/enums';
import { HeroBannerAssetProps } from './HeroBannerAsset.types';
import { StyledVerticalImageContainer, StyledFontIcon, StyledLogoImage } from './HeroBannerAsset.styles';
import { URL_CONSTANTS } from '../../../utils';

const { FONT_ICON } = AssetVariation;
const { SIZE_3x1 } = HeroSize;
const { PLACEHOLDER_IMAGE } = URL_CONSTANTS;
const { VERTICAL_IMAGE } = AssetVariation;
const HeroBannerAsset = (props: HeroBannerAssetProps) => {
  const {
    fileReferenceImageVertical,
    imgAltText,
    assetsVariation,
    verticalImageAltText,
    heroSize,
    fontIcon,
    fontIconAltText,
    fileReferenceImage,
    cobrandmathhero,
    isCopyBlockWidthWide,
  } = props;
  const isVerticalImage = !!(assetsVariation && assetsVariation === VERTICAL_IMAGE && fileReferenceImageVertical);
  return (
    <>
      {isCopyBlockWidthWide && isVerticalImage && fileReferenceImageVertical && (
        <StyledVerticalImageContainer>
          <img
            src={fileReferenceImageVertical}
            className={`styled${assetsVariation}`}
            alt={verticalImageAltText}
            title={verticalImageAltText}
            data-src={PLACEHOLDER_IMAGE}
          />
        </StyledVerticalImageContainer>
      )}
      {!isVerticalImage && (
        <div className="row">
          {assetsVariation === FONT_ICON && fontIcon ? (
            <div className="col-12 col-md-4 col-lg-6">
              <StyledFontIcon
                fontIcon={fontIcon}
                className={`m-icon brand-logo-${fontIcon}`}
                aria-labelledby={fontIconAltText || ''}
                data-testid={fontIcon}
              />
            </div>
          ) : (
            assetsVariation === AssetVariation.IMAGE &&
            fileReferenceImage && (
              <StyledLogoImage
                className={clsx('credit-card', {
                  'hb-flex': heroSize === SIZE_3x1,
                })}
                cobrandmathhero={cobrandmathhero as boolean}
              >
                <Image
                  title={imgAltText || 'Hero Card Image'}
                  customClass="logo-image"
                  loading="lazy"
                  defaultImageURL={fileReferenceImage}
                  altText={imgAltText}
                  dynamic={false}
                ></Image>
              </StyledLogoImage>
            )
          )}
        </div>
      )}
    </>
  );
};

export default HeroBannerAsset;
